import React from 'react';
import { Typography } from '@mui/material';
import { faLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-hot-toast';
import { SimpleTable } from './components/SimpleTable';
import { FiltersBar } from './CrmFiltersBar';

type AbandonedCartDto = {
  email: string;
  productId: number;
  productType: string;
  userId: number | null;
  lastActivityAt: string;
  productName: string;
  checkoutUrl: string;
  state: 'abandoned' | 'converted';
  convertedAt: string | null;
};

function createColumns() {
  return [
    {
      title: 'Email',
      render: (row: AbandonedCartDto) => (
        <span className="select-all">{row.email}</span>
      ),
    },
    {
      title: 'Product',
      render: (row: AbandonedCartDto) => <div>{row.productName}</div>,
    },
    {
      title: 'Type',
      render: (row: AbandonedCartDto) => <div>{row.productType}</div>,
    },
    {
      title: 'Status',
      render: (row: AbandonedCartDto) => (
        <div>{row.state === 'converted' ? 'Converted' : 'Abandoned'}</div>
      ),
    },
    {
      title: 'Converted at',
      render: (row: AbandonedCartDto) => (
        <div>
          {row.convertedAt
            ? new Date(row.convertedAt).toLocaleDateString()
            : '-'}
        </div>
      ),
    },
    {
      title: 'Last activity',
      render: (row: AbandonedCartDto) => (
        <div>{new Date(row.lastActivityAt).toLocaleDateString()}</div>
      ),
    },
    {
      title: 'Link',
      render: (row: AbandonedCartDto) => (
        <div
          className="w-full cursor-pointer"
          onClick={() => {
            navigator.clipboard.writeText(row.checkoutUrl);
            toast.success('Copied to clipboard');
          }}
        >
          <FontAwesomeIcon icon={faLink} color="#6367EF" />
        </div>
      ),
    },
  ].map((c) => ({ ...c, sorting: false }));
}

type AbandonedCartsTableProps = {
  data: AbandonedCartDto[];
  totalResults: number;
  isFetching?: boolean;
};
export function AbandonedCartsTable({
  data,
  totalResults,
  isFetching,
  ...props
}: AbandonedCartsTableProps) {
  const columns = createColumns();

  return (
    <div className="max-w-full">
      <FiltersBar totalResults={totalResults} isFetching={isFetching}>
        <></>
      </FiltersBar>
      <div className="my-3 text-sm text-[#8A8E99]">
        <Typography>
          Leads and existing customers who started a product checkout and
          haven&apos;t completed it. A row flips to Converted once they buy, and
          the Link reopens their checkout.
        </Typography>
      </div>
      <SimpleTable {...props} columns={columns} data={data} />
    </div>
  );
}
